import type { ParamValue, PreviewRequestBody } from '@/app/lib/quant/types'

/**
 * Keys the preview accepts and ignores inside `params` (P0 item 2, findings.md): the
 * window is the latest bars, and the top-level `instrument` wins over `params.instrument`.
 * They are still SENT (all coerced params go through unchanged) but never count as a change,
 * so editing them triggers no preview request.
 */
export const STRIPPED_PREVIEW_KEYS: readonly string[] = ['start', 'end', 'instrument']

export interface BuildPreviewBodyArgs {
  instrument: string
  tf: string
  bars: number
  values: Record<string, ParamValue>
  includeCandles: boolean
  /** True when the strategy form has an `instrument` param. */
  formHasInstrument: boolean
}

/** The POST body: exactly instrument, tf, bars, params, include_candles. */
export function buildPreviewBody(args: BuildPreviewBodyArgs): PreviewRequestBody {
  const params: Record<string, ParamValue> = { ...args.values }
  if (args.formHasInstrument) params.instrument = args.instrument
  return {
    instrument: args.instrument,
    tf: args.tf,
    bars: args.bars,
    params,
    include_candles: args.includeCandles,
  }
}

/** What the session compares to decide whether params changed; ignores `STRIPPED_PREVIEW_KEYS`, key-order independent. */
export function paramsChangeKey(values: Record<string, ParamValue>): string {
  const kept: Record<string, ParamValue> = {}
  for (const key of Object.keys(values).sort()) {
    if (!STRIPPED_PREVIEW_KEYS.includes(key)) kept[key] = values[key]
  }
  return JSON.stringify(kept)
}
